import { MealRow } from "@heliopolis/schema/meal-row.js";
import { Meal } from "@heliopolis/schema/meal.js";
import { array, nullish, object, string, type input, type output } from "zod";

/**
 * Input required to import meals from a Google Sheets range.
 */
export const ImportMealsArgs = object({
  sheetId: string().trim().nonempty(),
  range: string().trim().nonempty(),
});
export type ImportMealsArgs = input<typeof ImportMealsArgs>;

/**
 * Successful result of importing and parsing meals.
 */
export const ImportMealsSuccess = object({
  errors: nullish(array(string())),
  mealRows: array(MealRow),
  meals: array(Meal),
});
export type ImportMealsSuccess = output<typeof ImportMealsSuccess>;

/**
 * Backward-compatible aliases while migrating existing call sites.
 */
export const ImportArgs = ImportMealsArgs;
export type ImportArgs = ImportMealsArgs;

export const ImportSuccess = ImportMealsSuccess;
export type ImportSuccess = ImportMealsSuccess;
